import Utils from '../utils/utils';
import axios from "axios";
import { module } from 'modujs';
import {gsap} from 'gsap';

/**
 *
 */


export default class extends module {
  constructor(m) {
    super(m);

    this.$btn = this.el.querySelector('.load-more')
    this.$label = this.el.querySelector('.load-more span')
    this.$loader =  this.el.querySelector('.load-more .loader')
    this.$extraPost

    if (this.$btn) {
      this.setup()
    }

  }

  setup(){
    let self = this;

    this.$btn.addEventListener('click',  (e)=> {
      e.preventDefault();


      this.$btn.classList.add('hideLabel')
      gsap.to(this.$label,{y:-50,display:'block',duration:0.4})
      gsap.to(this.$loader,{top:0,duration:0.4})
      self.loadMore(this.$btn.dataset.paged, this.$btn.dataset.postCategory)
      //     // item.dataset.paged++
      this.$btn.dataset.paged = this.$btn.dataset.maxPage

    })


  }

  loadMore(paged, category) {

    Utils.debug('Home:LoadMore :' + category);
    let self = this
    this.contentData = []

    let form_data = new URLSearchParams();

    form_data.append('action', 'get_next_posts');
    form_data.append('paged', paged);
    form_data.append('category', category);
    form_data.append('_ajax_nonce', ajax_object.ajax_nonce);

    axios.post(ajax_object.ajax_url, form_data)

      .then((response) => {

        gsap.to(this.$loader,{opacity:0,duration:0.4,onComplete:()=>{
          gsap.set(this.$btn,{display:'none'})
          }})
        let content = document.querySelector("div#cat" + category)

        let data
        response['data']['data'].forEach(function (item) {
          data = item.substring(0,16) + ' extra-loaded-post ' +item.substring(16)
          content.insertAdjacentHTML('beforeend', data)
        })
        this.$extraPost = self.el.querySelectorAll('.extra-loaded-post')
        gsap.to(this.$extraPost,{opacity:1,display:'block',stagger:0.1,delay:0.3})


      })

      .catch((error) => {
        console.log(error);
      });


  }

  destroy(){
    console.log("DESTROY LOAD MORE")
  }

}



// WEBPACK FOOTER //
// ./scripts/modules/loadMore.js